import moment from "moment-timezone";
import { convert } from "html-to-text";
import { IApplicant, IProjectDetails, IJob } from "../RecruitersPanel/helper";

export const emailEditorRules = [
  { required: true, message: `Email body is required field` },
  () => ({
    validator(_: any, value: string) {
      if (value && convert(value).length > 3) return Promise.resolve();
      return Promise.reject(
        new Error("Email body must contain some valid text")
      );
    },
  }),
];

export const getSchduleMeetingBody = (
  candidateName: string,
  position: string,
  managerName: string,
  date: string,
  time: string,
) => {
  const [month, day] = date.split('-').map(Number);
  const currentYear = new Date().getFullYear();
  const nextYear = currentYear + 1;
  
  // Create a date object for the selected date
  const selectedDate = new Date(currentYear, month - 1, day);
  const currentDate = new Date();
  
  // If the selected date is in the past for current year, use next year
  const year = selectedDate < currentDate ? nextYear : currentYear;
  const dateVal = moment(`${year}-${month}-${day}`);

  return `<p>Your interview has been scheduled with <strong>${managerName}</strong> for the position of <strong>${position}</strong> on <strong>${dateVal.format('dddd, MMM DD, YYYY')}</strong> at <strong>${time}</strong>.</p>`;
};

export const getSubject = (
  emailType: string,
  candidateName: string,
  position: string
): string => {
  switch (emailType) {
    case "reminder":
      return `Reminder: Interview for ${candidateName} - ${position}`;
    case "schedule":
      return `Interview Scheduled for ${candidateName} - ${position}`;
    default:
      return "Important Interview Update";
  }
};


export const getReminderEmailBody = (
  candidate: IApplicant,
  job?: IJob,
  timeZone: string = "America/Los_Angeles"
) => {
  if (!job) return "";
  const { managers, companyName, positionTitle } = job;

  const { name, position, interviewLink, interviewDate, interviewType } =
    candidate;
  if (!interviewDate || interviewDate === "N/A") return "";

  const dateVal = moment(interviewDate).tz(timeZone);
  return `
    <p style="font-size:14px;margin-bottom:12px">
      <b>${name}'s </b>
      <span>interview has been scheduled with </span>
      <b>${managers?.[0]?.name || "Hiring Manager"} </b>
      <span>for the position of </span>
      <b>${position || positionTitle} </b>
      <span>for </span>
      <b>${companyName} </b>
      <span>on </span>
      <b>${dateVal.format("dddd, MMM DD, YYYY")} </b>
      <span>at </span>
      <b>${dateVal.format("hh:mm A")} </b>
      (${timeZone === "America/Los_Angeles" ? "PST" : timeZone}).
    </p>
    ${
      interviewLink && interviewLink !== "N/A"
        ? `<p style="font-size:14px;margin-bottom:12px">
      You can click 
      <a href=${interviewLink}>here </a>
      <span>to join the call as well.</span>
    </p>`
      : `<p style="font-size:14px;margin-bottom:12px">
      It will be an <strong>${interviewType}</strong> interview. 
    </p>`
    }
    </b>
    <p style="font-size:14px;margin-bottom:12px">Regards: The Chronoflow.ai team</p>`;
    
};
